@if (isReady() && streamUrl()) {
  <div
    class="flex items-center gap-3 rounded-lg bg-sky-50 border border-blue-200 px-3 py-2.5 shadow-sm hover:shadow-md transition-shadow"
    [style.width]="playerWidth()"
    style="max-width: 100%; min-width: 160px"
  >
    <button
      type="button"
      class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-sky-600 text-white shadow-md transition-all hover:bg-sky-700 hover:scale-105 active:scale-95 disabled:cursor-not-allowed disabled:bg-slate-300 disabled:shadow-none"
      (click)="togglePlayPause()"
      [disabled]="!streamUrl()"
      [attr.aria-label]="isPlaying() ? 'Pausar audio' : 'Reproducir audio'"
    >
      @if (isPlaying()) {
        <i class="bi bi-pause-fill text-base"></i>
      } @else {
        <i class="bi bi-play-fill text-base ml-0.5"></i>
      }
    </button>

    <div class="flex min-w-0 flex-1 flex-col gap-1.5">
      <div class="relative h-1 w-full bg-slate-200 rounded-full overflow-hidden">
        <div
          class="absolute h-full bg-sky-500 rounded-full transition-all"
          [style.width.%]="(currentTime() / (duration() || 1)) * 100"
        ></div>
        <input
          type="range"
          class="absolute inset-0 w-full opacity-0 cursor-pointer"
          [min]="0"
          [max]="duration() || 0"
          [step]="0.1"
          [value]="currentTime()"
          (input)="onSeek($event)"
          [attr.aria-label]="'Posición del audio: ' + formatTime(currentTime())"
        />
      </div>

      <div class="flex items-center justify-between px-1">
        <span class="text-xs font-semibold text-slate-700">{{ formatTime(currentTime()) }}</span>
        <span class="text-xs font-medium text-slate-500">{{ formatTime(duration()) }}</span>
      </div>
    </div>
  </div>
} @else {
  <div class="flex items-center gap-2 rounded-lg bg-slate-100 px-4 py-3 border border-slate-200">
    <i class="bi bi-mic-mute text-slate-500 text-lg"></i>
    <span class="text-sm font-medium text-slate-600">Audio no disponible</span>
  </div>
}

<audio
  #audioRef
  preload="metadata"
  [src]="streamUrl()"
  (loadedmetadata)="onLoadedMetadata($event)"
  (timeupdate)="onTimeUpdate($event)"
  (ended)="onEnded()"
  (pause)="isPlaying.set(false)"
  (play)="isPlaying.set(true)"
></audio>
